<template id="stats">
  <div>
    <b-row>
      <b-col cols="6">
        <h3 id="repoName"><b-icon-book /> {{ overview.name }}</h3>

        <div id="iconRow">
          <span v-if="overview.private">
            <b-badge variant="light" v-b-tooltip.hover title="Private">
              Private
            </b-badge>
          </span>
          <span v-else>
            <b-badge variant="success" v-b-tooltip.hover title="Public">
              public
            </b-badge>
          </span>

          <span class="p-1" />

          <span v-if="overview.compliant == -1">
            <b-badge variant="danger">
              <compliance-icon :complianceState="overview.compliant" />
            </b-badge>
          </span>
          <span v-else-if="overview.compliant == 1">
            <b-badge variant="success">
              <compliance-icon :complianceState="overview.compliant" />
            </b-badge>
          </span>
          <span v-else>
            <b-badge>
              <compliance-icon :complianceState="overview.compliant" />
            </b-badge>
          </span>
        </div>

        <p id="para">{{ overview.description }}</p>
        <p>
          <a
            :href="'https://github.com/' + overview.fullName"
            target="_blank"
            v-b-tooltip.hover
            title="View on GitHub"
          >
            <span class="fa fa-github" />
            http://github.com/{{ overview.fullName }}
            <span class="fa fa-external-link m-2"></span>
          </a>
        </p>
        <p>
          <b-icon-building />&nbsp;&nbsp;<b-link :to="`/org/${overview.orgid}`"
            >Org: {{ overview.organization }}</b-link
          >
        </p>
      </b-col>

      <b-col cols="6">
        <div class="text-right">
          <h4>
            <b-badge variant="light" pill>
              <star-icon /> {{ overview.starCount }}
            </b-badge>

            <b-badge variant="light" pill>
              <fork-icon /> {{ overview.forkCount }}
            </b-badge>

            <b-badge variant="light" pill>
              <watch-icon /> {{ overview.watcherCount }}
            </b-badge>
          </h4>
          <ul style="list-style-type: none">
            <li>
              <strong>Created: </strong>
              {{ overview.createdAt }}
            </li>
            <li>
              <strong>Updated: </strong>
              {{ updatedAt }}
            </li>
            <li>
              <strong>Pushed: </strong>
              {{ pushedAt }}
            </li>
          </ul>
          <p>({{ lastMaintained }} since last update)</p>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { yearMonthDayFormat } from "../common/time_utils";
import { ForkIcon, WatchIcon, ComplianceIcon, StarIcon } from "./icons";

export default {
  name: "stats",
  props: {
    overview: Object,
  },
  components: { ComplianceIcon, WatchIcon, ForkIcon, StarIcon },
  computed: {
    createdAt: function() {
      return yearMonthDayFormat(new Date(this.overview.createdAt));
    },
    updatedAt: function() {
      return yearMonthDayFormat(new Date(this.overview.updatedAt));
    },
    pushedAt: function() {
      return yearMonthDayFormat(new Date(this.overview.pushedAt));
    },
    lastMaintained: function() {
      return this.overview.lastMaintained;
    },
  },
};
</script>

<style scoped>
#iconRow {
  font-size: 1em;
  margin-bottom: 25px;
}

#repoName {
  margin-bottom: 5px;
}
</style>
